var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V48H44V0H40Z",
    fill: "#E5FDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 7.48633L37.0107 24L18.6621 40.5137L21.3379 43.4863L41.3379 25.4863V22.5137L21.3379 4.51367L18.6621 7.48633Z",
    fill: "#E5FDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22V26H40V22H4Z",
    fill: "#E5FDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.1a19231e858b7cf57c5b057c63db86de.svg";
export { ForwardRef as ReactComponent };